import { FeatureFlag } from '../FeatureFlag';

export const enableLab2LocateInjection = new FeatureFlag({
    key: 'enable-lab-2-locate-injection',
    createdOn: '2026-08-06',
    defaultValue: false,
});
